import React, { useState, useCallback } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { Box, Typography, Button } from "@mui/material";

const DateRangePicker = ({ onChange }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleStartDateChange = useCallback((newValue) => {
        setStartDate(newValue);
        if (endDate && newValue && endDate < newValue) {
            setEndDate(null);
        }
        onChange([newValue ? new Date(newValue) : null, endDate ? new Date(endDate) : null]);
    }, [endDate, onChange]);

    const handleEndDateChange = useCallback((newValue) => {
        setEndDate(newValue);
        onChange([startDate ? new Date(startDate) : null, newValue ? new Date(newValue) : null]);
    }, [startDate, onChange]);

    const handleClear = useCallback(() => {
        setStartDate(null);
        setEndDate(null);
        onChange([null, null]);
    }, [onChange]);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", gap: 2, justifyContent: "center", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="body2">Από:</Typography>
                <DatePicker
                    value={startDate}
                    onChange={handleStartDateChange}
                    format="DD/MM/YYYY"
                    slotProps={{
                        textField: {
                            variant: "outlined",
                            fullWidth: true,
                            sx: {
                                '& .MuiInputBase-input': { color: "black" },
                                '& .MuiOutlinedInput-input': { color: "black" }
                            }
                        }
                    }}
                />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography variant="body2">Έως:</Typography>
                <DatePicker
                    value={endDate}
                    onChange={handleEndDateChange}
                    minDate={startDate}
                    format="DD/MM/YYYY"
                    slotProps={{
                        textField: {
                            variant: "outlined",
                            fullWidth: true,
                            sx: {
                                '& .MuiInputBase-input': { color: "black" },
                                '& .MuiOutlinedInput-input': { color: "black" }
                            }
                        }
                    }}
                />
            </Box>
            <Button
                variant="standard"
                onClick={handleClear}
                sx={{
                    backgroundColor: 'white !important',
                    color: "black",
                }}
            >
                Επαναφορά
            </Button>
        </Box>
    );
};

export default DateRangePicker;
